<div class="position-relative text-grey">
  <div class="modal-header">
    <h4 class="modal-title synchpc-primary" id="modal-title">{{ this.data?.licenseObj ? "Update" : "Add" }} License Server</h4>
    <i style="z-index: 1"
       class="bi bi-x-lg text-danger"
       color="warn"
       (click)="onClose()"
       title="Close"></i>
  </div>
  <div class="modal-body">
    <form action="" [formGroup]="addLicenseServerForm" autocomplete="off" spellcheck="false">
      <mat-form-field style="width: 100%">
        <mat-label>License Name</mat-label>
        <input matInput
               placeholder="License Name"
               formControlName="licenseName"
               title="License name can only contain alphabets, numbers, . _ -" />
        <mat-error *ngIf="
            addLicenseServerForm.get('licenseName').touched &&
            addLicenseServerForm.get('licenseName').errors?.required
          ">Required</mat-error>
        <mat-error *ngIf="addLicenseServerForm.get('licenseName').errors?.pattern">Enter valid User Id.</mat-error>
      </mat-form-field>
      <mat-form-field appearance="fill" style="width: 100%">
        <mat-label>License Type</mat-label>
        <mat-select formControlName="licenseType">
          <mat-option *ngFor="let type of licenseTypes"
                      value="{{ type.value }}">{{ type.name }}</mat-option>
        </mat-select>
        <mat-error *ngIf="
            addLicenseServerForm.get('licenseType').touched &&
            addLicenseServerForm.get('licenseType').errors?.required
          ">Required</mat-error>
      </mat-form-field>
      <mat-form-field style="width: 100%">
        <mat-label>License Host</mat-label>
        <input matInput
               placeholder="License Host"
               formControlName="licenseHost"
               title="Host can only contain alphabets, numbers, . _ -" />
        <mat-error *ngIf="
            addLicenseServerForm.get('licenseHost').touched &&
            addLicenseServerForm.get('licenseHost').errors?.required
          ">Required</mat-error>
        <mat-error *ngIf="addLicenseServerForm.get('licenseHost').errors?.pattern">Enter valid User Id.</mat-error>
      </mat-form-field>
      <mat-form-field style="width: 100%">
        <mat-label>License Port</mat-label>
        <input matInput
               type="number"
               placeholder="License Port"
               formControlName="licensePort"
               title="User Id can be of maximum 2 to 35 characters containing alphabets, numbers, . _ -" />
        <mat-error *ngIf="
            addLicenseServerForm.get('licensePort').touched &&
            addLicenseServerForm.get('licensePort').errors?.required
          ">Required</mat-error>

        <mat-error *ngIf="addLicenseServerForm.get('licensePort').touched &&
            addLicenseServerForm.get('licensePort').errors?.min
          ">Port must be greater than 0</mat-error>
        <mat-error *ngIf="addLicenseServerForm.get('licenseHost').errors?.pattern">Enter numbers only.</mat-error>
      </mat-form-field>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="onClose()">
      Close
    </button>
    <button type="submit" class="btn btn-primary" (click)="submitForm()">
      Submit
    </button>
  </div>
  <ngx-spinner bdColor="rgba(0,0,0,0)"
               name="inProgressAddUpdate"
               size="default"
               zIndex="1"
               color="var(--s-primary-color)"
               type="ball-spin"
               [fullScreen]="false"><p class="pleaseWait">Please wait ...</p></ngx-spinner>
</div>
